import { observer } from 'mobx-react-lite'
import { type JobDetailsViewModel } from '@/features/jobs/details/JobDetailsViewModel'
import { JobSummaryCard } from '@/features/jobs/details/components/JobSummaryCard'

export interface JobSummaryCardContainerProps {
  vm: JobDetailsViewModel
}

export const JobSummaryCardContainer = observer(
  function JobSummaryCardContainer({ vm }: JobSummaryCardContainerProps) {
    return (
      <JobSummaryCard
        shortId={vm.job.shortId}
        workspaceName={vm.jobWorkspace.name}
        showConsultationCallTime={vm.job.hasActiveConsultation}
        consultationCallTime={vm.consultationVm.consultationCallTimeText}
        showLegend={vm.canViewLegendNameAsAdmin}
        legendText={vm.legendText}
        serviceItemsCount={vm.scopeChangesVm.serviceItemsListLength}
        onViewServiceItems={vm.scopeChangesVm.serviceItemListVm.show}
        bundleName={vm.job.jobBundle?.name}
        showProviderCut={vm.shouldShowProviderCutAmount}
        formattedProviderCutAmount={vm.formattedProviderCutAmount}
        dateSubmitted={vm.job.dateSubmitted}
        dateDeadline={vm.job.dateDeadline}
        showPrepAndReview={!!vm.job.containsPrepAndReviewLink}
        prepAndReviewJobText={vm.job.prepAndReviewJobText}
        prepAndReviewJobLinkType={vm.job.prepAndReviewJobLinkType}
        onViewPrepAndReviewJob={vm.viewPrepAndReviewJob}
        showJobTotal={vm.shouldShowJobTotal}
        total={vm.job.total}
      />
    )
  },
)
